import { useNavigate } from 'react-router';
import { useBaseAuthenticated, usePlatformCreateReport } from 'shared/base';

import { buildYourOwnTemplate } from '../templates';
import { generateReportObjectWithYamlFromTemplate } from '../utils';
import { getReportUrl } from '../utils/navigation';

export function useTemplate(templateId: string) {
  const { mutateAsync: createReport } = usePlatformCreateReport();

  const { currentMembership } = useBaseAuthenticated();
  const navigate = useNavigate();

  const handleCreateFromTemplate = async () => {
    const report = await generateReportObjectWithYamlFromTemplate(templateId);
    const data = await createReport({
      data: {
        content: report.content,
        description: report.description,
        private: true,
        template_id: templateId,
        title: report.title,
      },
      teamName: currentMembership.team.name,
    });

    navigate(getReportUrl(data.data.data.id, currentMembership.team.name));
  };

  const handleCreateFromYaml = async (yaml: string, title: string, description: string) => {
    const data = await createReport({
      data: { content: yaml, description, private: true, title },
      teamName: currentMembership.team.name,
    });

    navigate(getReportUrl(data.data.data.id, currentMembership.team.name, true));
  };

  return {
    handleCreateFromTemplate,
    handleCreateFromYaml,
    isCreateFromScratchTemplate: templateId === buildYourOwnTemplate.id,
  };
}
